import * as XLSX from 'xlsx'

export function downloadLeadTemplate() {
  const worksheet = XLSX.utils.aoa_to_sheet([
    [
      'Full Name',
      'Company',
      'Phone',
      'Email',
      'Product',
      'Quantity',
      'Value',
      'Source',
      'Qualification',
    ],
  ])

  worksheet['!cols'] = [
    { wch: 18 },
    { wch: 18 },
    { wch: 14 },
    { wch: 24 },
    { wch: 28 },
    { wch: 14 },
    { wch: 14 },
    { wch: 12 },
    { wch: 18 },
  ]

  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Lead Template')
  XLSX.writeFile(workbook, 'Lead_Template.xlsx')
}
